/**
 * Created by Xuz on 2020/01/08.
 * xuz@live.cn
 *
 * 我们的故事从这里开始...
 */
import * as WFC from '../WFConstants'
import WFNode from '../WFNode'

class TBStartNode {
  constructor (workflow) {
    this.workflow = workflow
    this.$_c = this.workflow.parent.$_c
  }

  doMouseDown (event) {
    let el = this.workflow.getSelectedElement(event)
    if (el == null) {
      if (this.workflow.getStartNode() != null) {
        this.workflow.setMessage('startnode.onlyone')
        this.workflow.setUnSelectLastElement(event)
        return
      }

      el = new WFNode(this.workflow, WFC.NODE_TYPE_START_NODE)
      el.create(event)
      this.workflow.setActiveElement(el, event)
    } else {
      this.workflow.setActiveElement(el, event)
    }
  }

  doMouseMove (event) {
    const el = this.workflow.getLastElement(event)
    el.onMove(event)
  }

  doMouseUp (event) {
    const el = this.workflow.getLastElement(event)
    if (el == null) {
      return
    }
    el.onUp(event)
  }

  doMouseDblClick (event) {
    const el = this.workflow.getSelectedElement(event)
    if (el == null) {
      this.workflow.setUnSelectLastElement(event)
    } else {
      if (el === this.workflow.getLastElement()) {
        el.onMouseDblClick(event)
      } else {
        this.workflow.setActiveElement(el, event)
      }
    }
  }

  getName () {
    return '起点'
  }

  getIcon () {
    return this.$_c + 'app/workflow/img/design/start.png'
  }
}

export default TBStartNode
